var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGripIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 52,
    viewBox: "0 0 17 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 18,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 18,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 24,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 24,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 30,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 30,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 30,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 36,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 36,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 36,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 42,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 42,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 42,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 48,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 48,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 48,
    width: 4,
    height: 4,
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripIndicator);
export default __webpack_public_path__ + "static/media/GripIndicator.a7d51e3b19f77c15c963ca19a7e62f0d.svg";
export { ForwardRef as ReactComponent };